<template>
    <v-modal-slot :title="name"
             size="xl"
             id="show-attorneys-modal"
             @closed="closeModal">
        <template v-slot:modal-title>
            {{ name }}
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12 text-center">
                    <img :src="base64" style="max-width: 100%;" />
                </div>
            </div>
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>

</template>

<script>
import VModal from "../../../general/VModal";
import VModalSlot from "../../../general/VModalSlot";

export default {
    name: "ExpedientDetailShowMedia",
    components: {VModalSlot, VModal},
    props: {
        name: {
            type: String,
            required: true,
        },
        base64: {
            type: String,
            required: true,
        }
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
